import { useEffect, useState } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappLink = 'https://wa.me/5551982147466';

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      {/* Navegação */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 h-16 sm:h-20 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-4">
            <img 
              src="https://static.readdy.ai/image/efe8862384220dffaa2ccdfbb3424084/6274abfb7d5693773050b6e71875cf99.jpeg" 
              alt="Shaiane Costa" 
              className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover"
            />
            <span className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#C17B6F]" style={{ fontFamily: "'Great Vibes', cursive" }}>Shaiane Costa</span>
          </div>
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#25D366] hover:text-[#1da851] transition-colors"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <span className="hidden sm:inline font-medium">Contato</span>
          </a>
        </div>
      </nav>

      {/* BLOCO 1 - Hero Section */}
      <section className="relative min-h-screen flex items-center pt-16 sm:pt-20">
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/71019521ac3e837ac77758d036aee0b2.jpg" 
            alt="Ambiente terapêutico" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#FAF8F5]/95 via-[#FAF8F5]/85 to-transparent"></div>
          <div className="absolute top-20 right-20 w-96 h-96 rounded-full bg-[#C17B6F]/10 blur-3xl hidden lg:block"></div>
          <div className="absolute bottom-40 right-60 w-64 h-64 rounded-full bg-[#E8C4BC]/20 blur-2xl hidden lg:block"></div>
        </div>

        <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-16 sm:py-20">
          <div className="space-y-6 sm:space-y-8 max-w-xl">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-semibold text-[#2C2C2C] leading-tight">
              Psicoterapia Online<br />
              <span className="text-[#C17B6F]">Terapia Cognitivo-Comportamental</span>
            </h1>
            
            <p className="text-xl sm:text-2xl lg:text-3xl text-[#C17B6F] font-medium">
              Quando a mente desacelera, a vida volta a fluir.
            </p>
            
            <p className="text-base sm:text-lg text-[#6B6B6B] leading-relaxed">
              Atendimento acolhedor, estruturado e baseado em evidências.
            </p>
            
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#25D366] text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-semibold hover:bg-[#1da851] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 animate-pulse hover:animate-none whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl sm:text-2xl"></i>
              Agendar pelo WhatsApp
              <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      {/* BLOCO 2 - Identificação */}
      <section className="bg-gradient-to-br from-[#C17B6F] to-[#D89A8F] py-10 sm:py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Imagem */}
            <div className="flex justify-center">
              <div className="relative w-full max-w-xs sm:max-w-sm lg:max-w-md">
                <div className="rounded-3xl overflow-hidden shadow-2xl w-full h-64 sm:h-96 lg:h-[520px]">
                  <img
                    src="https://static.readdy.ai/image/efe8862384220dffaa2ccdfbb3424084/b4ba9a670a06648929e400a013e56e72.jpeg"
                    alt="Pessoa refletindo sobre seus sentimentos"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F5EFE7] mb-6 sm:mb-8">
                Você se identifica?
              </h2>
            
              <div className="space-y-3 sm:space-y-4">
                {[
                  'Mente acelerada o tempo todo?',
                  'Autocrítica excessiva?',
                  'Ansiedade pelo passado ou futuro?',
                  'Dificuldade de dizer "não"?',
                  'Sensação constante de alerta?',
                  'Padrões que se repetem?'
                ].map((item, index) => (
                  <div 
                    key={index}
                    className="bg-white/8 backdrop-blur-sm rounded-2xl p-4 sm:p-6 flex items-start gap-3 sm:gap-4 hover:bg-white/12 transition-all duration-300"
                  >
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[#C17B6F] flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-base sm:text-lg"></i>
                    </div>
                    <p className="text-white text-base sm:text-lg leading-relaxed">{item}</p>
                  </div>
                ))}
                
                <div className="pt-6 sm:pt-8 text-center">
                  <p className="text-[#F5EFE7] text-base sm:text-xl italic leading-relaxed max-w-xl mx-auto mb-6 sm:mb-8">
                    A terapia pode te ajudar a compreender seus padrões e construir novas formas de lidar com tudo isso, marcando o início de um novo ciclo.
                  </p>
                  
                  <a 
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#25D366] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-[#1da851] transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
                    Quero agendar minha sessão
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOCO 2.5 - Pilares da TCC */}
      <section className="py-10 sm:py-12 lg:py-16 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
          <div className="text-center mb-8 sm:mb-10 lg:mb-12">
            <span className="inline-block bg-[#C17B6F]/15 text-[#C17B6F] px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold uppercase tracking-widest mb-4 sm:mb-6">
              Entenda a minha abordagem
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 sm:mb-6 leading-tight">
              Os Pilares da Terapia<br />
              <span className="text-[#C17B6F]">Cognitivo-Comportamental</span>
            </h2>
            <p className="text-[#6B6B6B] text-base sm:text-xl max-w-2xl mx-auto leading-relaxed">
              Uma abordagem prática, estruturada e baseada em evidências para quem deseja mudanças concretas, não apenas desabafar.
            </p>
            <div className="w-16 h-1 bg-[#C17B6F] mx-auto rounded-full mt-6 sm:mt-8"></div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 mb-8 sm:mb-10">
            {[
              {
                number: '01',
                icon: 'ri-mind-map',
                title: 'Pensamentos',
                subtitle: 'Cognição',
                description: 'Muitas vezes, a ansiedade nasce da forma como interpretamos as situações. Na terapia, você aprende a identificar pensamentos automáticos, questionar reflexões e desenvolver uma visão mais equilibrada da realidade.',
                color: '#C17B6F',
                bg: '#FAF0EE',
              },
              {
                number: '02',
                icon: 'ri-emotion-line',
                title: 'Emoções',
                subtitle: 'Afeto',
                description: 'Aqui, você aprende a reconhecer suas emoções, entender suas origens e desenvolver recursos para lidar com elas de forma saudável.',
                color: '#3A4F5C',
                bg: '#EEF2F5',
              },
              {
                number: '03',
                icon: 'ri-run-line',
                title: 'Comportamentos',
                subtitle: 'Ação',
                description: 'Agir para transformar. Pequenas mudanças nas ações geram grandes transformações na vida. A TCC trabalha com estratégias práticas para que você saia do ciclo da evitação e desenvolva atitudes mais alinhadas com quem deseja se tornar.',
                color: '#7A9E7E',
                bg: '#EEF5EE',
              }
            ].map((pillar, index) => (
              <div
                key={index}
                className="relative bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-2xl transition-all duration-400 hover:-translate-y-2 overflow-hidden group cursor-pointer"
              >
                <div
                  className="absolute top-0 left-0 right-0 h-1.5 rounded-t-3xl"
                  style={{ backgroundColor: pillar.color }}
                ></div>

                <div className="flex items-start justify-between mb-6 sm:mb-8">
                  <div
                    className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center"
                    style={{ backgroundColor: pillar.bg }}
                  >
                    <i className={`${pillar.icon} text-2xl sm:text-3xl`} style={{ color: pillar.color }}></i>
                  </div>
                  <span
                    className="text-5xl sm:text-6xl font-bold opacity-10 leading-none"
                    style={{ color: pillar.color }}
                  >
                    {pillar.number}
                  </span>
                </div>

                <div className="mb-2">
                  <span
                    className="text-xs font-bold uppercase tracking-widest"
                    style={{ color: pillar.color }}
                  >
                    {pillar.subtitle}
                  </span>
                </div>
                <h3 className="font-serif text-2xl sm:text-3xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
                  {pillar.title}
                </h3>
                <p className="text-[#6B6B6B] text-sm sm:text-base leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-2">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#25D366] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-[#1da851] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl sm:text-2xl"></i>
              Agendar pelo WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* BLOCO 3 - Benefícios da TCC */}
      <section className="py-10 sm:py-12 lg:py-16 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
          <div className="text-center mb-8 sm:mb-10 lg:mb-12">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 sm:mb-6">
              Como a TCC<br />pode te ajudar
            </h2>
            <div className="w-16 h-1 bg-[#C17B6F] mx-auto rounded-full"></div>
          </div>
          
          <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
            {[
              {
                icon: 'ri-brain-line',
                title: 'Organização de pensamentos',
                description: 'Identifique e reorganize padrões mentais que alimentam a ansiedade.'
              },
              {
                icon: 'ri-tools-line',
                title: 'Estratégias práticas',
                description: 'Aprenda ferramentas concretas para lidar melhor com desafios do dia a dia.'
              },
              {
                icon: 'ri-leaf-line',
                title: 'Redução da ansiedade',
                description: 'Técnicas baseadas em evidências para diminuir sintomas físicos e emocionais.'
              },
              {
                icon: 'ri-heart-pulse-line',
                title: 'Fortalecimento emocional',
                description: 'Desenvolva segurança, autonomia e equilíbrio emocional duradouro.'
              }
            ].map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-3xl p-8 sm:p-10 lg:p-12 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#C17B6F]/20 flex items-center justify-center mb-4 sm:mb-6">
                  <i className={`${benefit.icon} text-2xl sm:text-3xl text-[#C17B6F]`}></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
                  {benefit.title}
                </h3>
                <p className="text-[#6B6B6B] text-base sm:text-lg leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 sm:mt-10">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#25D366] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-[#1da851] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl sm:text-2xl"></i>
              Quero começar minha terapia
            </a>
          </div>
        </div>
      </section>

      {/* BLOCO 4 - Sobre a Psicóloga */}
      <section className="py-10 sm:py-12 lg:py-16 bg-gradient-to-br from-[#FAF8F5] to-[#F5EFE7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
          <div className="grid lg:grid-cols-5 gap-10 lg:gap-16 items-center">
            <div className="lg:col-span-2 flex justify-center">
              <div className="relative">
                <div className="w-56 h-56 sm:w-72 sm:h-72 lg:w-96 lg:h-96 rounded-full border-8 border-[#C17B6F] overflow-hidden shadow-2xl">
                  <img 
                    src="https://static.readdy.ai/image/efe8862384220dffaa2ccdfbb3424084/6bf99591cf189fd6bde986603521360f.jpeg" 
                    alt="Psicóloga Shaiane Costa da Silva" 
                    className="w-full h-full object-cover scale-150"
                    style={{ objectPosition: '50% 18%' }}
                  />
                </div>
                <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full bg-[#C17B6F]/30 blur-2xl"></div>
              </div>
            </div>
            
            <div className="lg:col-span-3 space-y-4 sm:space-y-6">
              <div className="inline-block bg-[#C17B6F] text-white px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold uppercase tracking-wider">
                CRP 07/27509
              </div>
              
              <h2 className="font-serif font-bold text-[#2C2C2C]" style={{ fontFamily: "'Great Vibes', cursive", fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}>
                Shaiane Costa
              </h2>
              
              <div className="space-y-4 sm:space-y-5 text-[#6B6B6B] text-base sm:text-lg leading-relaxed max-w-2xl">
                <p>
                  Sou <strong className="text-[#2C2C2C]">Shaiane Costa da Silva</strong>, psicóloga clínica (CRP 07/27509), graduada em Psicologia. Minha trajetória profissional foi construída unindo base científica, experiência hospitalar e prática clínica contínua, sempre com foco na compreensão profunda do sofrimento emocional.
                </p>
                <p>
                  Durante minha formação, atuei no <strong className="text-[#2C2C2C]">Hospital São Francisco (Santa Casa de Porto Alegre)</strong>, acompanhando pacientes cardiopatas em UTI cirúrgica e CTI clínica, além de coordenar grupos terapêuticos com pacientes e familiares. Desenvolvi inúmeros trabalhos científicos com foco em psicoeducação, ansiedade, luto e acolhimento em situações de alta vulnerabilidade emocional.
                </p>
                <p>
                  Ao longo da minha trajetória, também participei de grupos terapêuticos voltados à transtornos de ansiedade na <strong className="text-[#2C2C2C]">APORTA – Associação para Portadores de Transtornos da Ansiedade</strong>, aprofundando minha compreensão sobre os impactos da ansiedade na vida adulta.
                </p>
                <p>
                  Desde 2020, atuo exclusivamente na clínica, oferecendo <strong className="text-[#2C2C2C]">atendimento online para adultos</strong>.
                </p>
              </div>
              
              <div className="pt-2 sm:pt-4">
                <p className="text-[#C17B6F] text-lg sm:text-xl font-semibold">
                  CRP 07/27509
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOCO 5 - Como funciona */}
      <section className="py-10 sm:py-12 lg:py-16 bg-[#E8EEF2]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-20">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2C2C2C] text-center mb-8 sm:mb-10">
            Como funciona a terapia?
          </h2>
          
          <div className="space-y-4 sm:space-y-5">
            {[
              { 
                icon: 'ri-computer-line', 
                title: 'Sessões 100% online',
                text: 'Atendimento seguro e confortável, onde você estiver.' 
              },
              { 
                icon: 'ri-time-line', 
                title: 'Duração de 50 minutos.',
                text: 'Tempo estruturado para aprofundar, refletir e aplicar estratégias.' 
              },
              { 
                icon: 'ri-user-line', 
                title: 'Atendimento individual',
                text: 'Um espaço exclusivo, focado na sua história e nas suas necessidades.' 
              },
              { 
                icon: 'ri-shield-check-line', 
                title: 'Sigilo e ética profissional',
                text: 'Compromisso absoluto com confidencialidade e respeito.' 
              }
            ].map((item, index) => (
              <div 
                key={index}
                className="flex items-start gap-4 sm:gap-6 group"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-md group-hover:shadow-lg transition-all duration-300 group-hover:scale-110">
                  <i className={`${item.icon} text-xl sm:text-2xl text-[#C17B6F]`}></i>
                </div>
                <div>
                  <p className="text-[#2C2C2C] text-lg sm:text-xl font-semibold">{item.title}</p>
                  <p className="text-[#6B6B6B] text-base sm:text-lg mt-1">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-7 sm:mt-8 bg-white rounded-2xl p-6 sm:p-8 text-center shadow-md">
            <p className="text-[#6B6B6B] text-base sm:text-lg italic leading-relaxed">
              A mesma profundidade da terapia presencial, com a flexibilidade do online.
            </p>
          </div>

          <div className="mt-5 sm:mt-6 space-y-4 text-[#4A4A4A] text-base sm:text-lg leading-relaxed">
            <p>
              Se você busca um acompanhamento psicológico sério, baseado em evidências e conduzido com <strong className="text-[#2C2C2C]">respeito ao seu ritmo</strong>, estou aqui para caminhar com você nesse processo.
            </p>
          </div>

          <div className="text-center mt-8 sm:mt-10">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#25D366] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-[#1da851] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl sm:text-2xl"></i>
              Agendar minha sessão
            </a>
          </div>
        </div>
      </section>

      {/* BLOCO 6 - CTA Final */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-[#C17B6F] to-[#D89A8F] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 rounded-full bg-white blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-80 h-80 rounded-full bg-white blur-3xl"></div>
        </div>
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="font-serif text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight drop-shadow-lg">
            Talvez você tenha aprendido a ser forte o tempo todo, mas também pode aprender a viver com mais leveza.
          </h2>
          
          <p className="text-white/90 text-lg sm:text-2xl font-light mb-8 sm:mb-12">
            Buscar ajuda é um ato de coragem.
          </p>
          
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 sm:gap-4 bg-white text-[#25D366] px-8 sm:px-12 py-4 sm:py-6 rounded-full text-base sm:text-xl font-bold hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-3xl animate-pulse hover:animate-none whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill text-2xl sm:text-3xl"></i>
            Agendar pelo WhatsApp
            <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
          </a>
        </div>
      </section>

      {/* Rodapé */}
      <footer className="bg-[#1A1A1A] py-8 sm:py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
          <div className="flex flex-col items-center gap-4 sm:gap-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/efe8862384220dffaa2ccdfbb3424084/6274abfb7d5693773050b6e71875cf99.jpeg" 
                alt="Shaiane Costa" 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover"
              />
              <span className="text-xl sm:text-2xl font-semibold text-white" style={{ fontFamily: "'Great Vibes', cursive" }}>Shaiane Costa</span>
            </div>
            <p className="text-white/60 text-xs sm:text-sm text-center">
              CRP 07/27509 | Psicóloga Clínica | Terapia Cognitivo-Comportamental
            </p>
            <p className="text-white/40 text-xs sm:text-sm text-center">
              © 2026 Shaiane Costa da Silva. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
